// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__KPMR6","dark":"button_dark__3sjKr","disabled":"button_disabled__p2rOn","light":"button_light__dtto4","peach":"button_peach__2tMqc"};